import { Component, Link } from '@mna/react'
import LoadingSpinner from './LoadingSpinner'

export default class LoadingScreen extends Component {

  state = {
    minDurationDone: false
  }

  componentDidMount() {
    const { minDuration = 1000 } = this.props
    this.timer = setTimeout(() => this.setState({ minDurationDone: true }), minDuration)
  }

  componentWillUnmount() {
    clearTimeout(this.timer)
  }

  render() {
    const { isLoading = false, children } = this.props
    return (
      isLoading || !this.state.minDurationDone
        ? <LoadingSpinner />
        : children
    )
  }
}
